<div class="swiper-carousel-wrapper">
  <swiper #swiper slidesPerView="auto" [spaceBetween]="spaceBetween" [navigation]="false" [pagination]="false"
    [loop]="false" [watchOverflow]="true" (activeIndexChange)="onSwiperActiveIndexChange()"
    (lock)="onSwiperLock()" (unlock)="onSwiperUnlock()">
    <ng-container *ngFor="let video of videoUrls; let idx = index; trackBy: trackByFn">
      <ng-template swiperSlide>
        <div class="carousel-item">
          <div [class]="itemClass" (mousedown)="onTouchStart($event)" (mousemove)="onTouchMove($event)"
            (mouseup)="onTouchEnd($event, video)" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)"
            (touchend)="onTouchEnd($event, video)" class="ss-l-video-container-widget "
            *ngIf="!video.isLoading; else loadingTemplate">
            <img [src]="video.thumbnail" class="ss-l-img-carousel" (click)="openModal(video)" />


            <div *ngIf="showDescription" style="max-width: 90%;" (click)="openModal(video)"
              class="py-1 px-2 mb-0 text-base card border-none text-left shadow-none font-semibold two-line-ellipsis"
              [style.background]="backgroundColor" [style.color]="font_color" [ngClass]="['p-description', position]">
              {{ video.description }}
            </div>

            <div class="ss-l-new-desc-prod">
              <!-- Produto dentro do vídeo -->
              <div *ngIf="showProducts && video.products && video.products.length > 0 && video.products[0].show_item"
                class="ss-g-product-overlay shadow-none" (click)="openModal(video)">

                <!-- Imagem do Produto -->
                <div class="ss-g-product-image">
                  <img [src]="video.products[0].image || 'assets/imgTmp.webp'" [alt]="video.products[0].name"
                    class="product-thumbnail">
                </div>

                <!-- Informações do Produto -->
                <!-- Informações do Produto -->
                <div class="ss-g-product-info flex flex-column w-full overflow-hidden">
                  <div class="ss-g-product-title white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ video.products[0].name }}
                  </div>

                  <div class="ss-g-product-details-carousel s-s-l-price">
                    <span *ngIf="hasDiscount(video.products[0])" class="line-through mr-2">
                      R$ {{ video.products[0].compare_at_price }}
                    </span>

                    <span class="font-bold">
                      {{ video.products[0].price | currency:'BRL':'symbol':'1.2-2' }}
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <ng-template #loadingTemplate>
            <div class="loading-spinner">
              <i class="pi pi-spin pi-spinner text-4xl"></i>
            </div>
          </ng-template>
        </div>
      </ng-template>
    </ng-container>
  </swiper>
  <!-- ✅ Setas de navegação personalizadas — escondidas quando o Swiper está
       "locked" (watchOverflow: não há slides escondidos pra navegar) -->
  <ng-container *ngIf="!isSwiperLocked">
    <div class="swiper-nav-btn-prev" (click)="swiperInstanceCarousel?.slidePrev()">
      <button pButton icon="pi pi-chevron-left" class="circular-nav-button"></button>
    </div>

    <div class="swiper-nav-btn-next" (click)="swiperInstanceCarousel?.slideNext()">
      <button pButton icon="pi pi-chevron-right" class="circular-nav-button"></button>
    </div>
  </ng-container>
</div>
